// import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import * as Tabs from 'vue-slim-tabs';
import Vuelidate from 'vuelidate';
import axios from 'axios';
import DateInput from './components/Utils/DateInput';
import Loading from './components/Utils/Loading';
import Notifications from 'vue-notification';
import draggable from 'vuedraggable';
import LinkButton from './components/Buttons/LinkButton';
import Button from './components/Buttons/Button';
import IconButton from './components/Buttons/IconButton';
import moment from 'moment';
import Modal from "./components/Modal";
import VueFabric from './components/vuejs-fabric';
import VTooltip from 'v-tooltip';
import ToggleButton from 'vue-js-toggle-button';
import VueCarousel from 'vue-carousel';
import ConfirmationModal from './components/Utils/ConfirmationModal';
import * as VueWindow from '@hscmap/vue-window'

moment.locale('pt-br');
axios.defaults.withCredentials = true;
Vue.component('VueFabric',VueFabric);

const shared = {
  endpoint: process.env.VUE_APP_API_ENDPOINT
}

shared.install = function () {
  Object.defineProperty(Vue.prototype, '$global', {
    get() { return shared }
  })
}

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
  }
});

Vue.use(VueWindow)
Vue.use(VueCarousel);
Vue.use(ToggleButton)
Vue.use(Notifications);
Vue.use(VTooltip)
Vue.component('confirmation-modal',ConfirmationModal);
Vue.component('modal-vue', Modal);
Vue.component('icon-button', IconButton);
Vue.component('lms-button', Button);
Vue.component('link-button', LinkButton);
Vue.component('draggable', draggable);
Vue.component('date-input', DateInput);
Vue.component('loading', Loading);
Vue.use(shared);
Vue.use(Tabs);
Vue.use(Vuelidate);
//require('./assets/styles/lms/lms.css');
require('./assets/styles/main.scss');
require('./assets/styles/vue-slim-tabs.scss');
//require('./assets/styles/teste.css');
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
